import React, { ReactNode, useMemo, useState } from 'react';

import styles from '@styles/jumbotron.module.scss';
import { BreadCrumb } from './BreadCrumb';
import { Button, Grid } from 'antd';

type Props = {
  pageName: string;
  breadCrumb: number[];
  title: string;
  desc?: string;
  breadCrumbChildren?: ReactNode;
};

const Jumbotron: React.FC<Props> = ({ pageName, breadCrumb, breadCrumbChildren, title, desc }) => {
  const [showMore, setShowMore] = useState(true);
  const { useBreakpoint } = Grid;
  const { xs, sm, md, lg, xl, xxl } = useBreakpoint();

  const showButton = useMemo(() => {
    if (xs) {
      return desc?.length > 150 ? true : false;
    } else if (!sm) {
      return desc?.length > 290 ? true : false;
    } else if (!md) {
      return desc?.length > 390 ? true : false;
    } else if (!lg) {
      return desc?.length > 377 ? true : false;
    } else if (!xl) {
      return desc?.length > 420 ? true : false;
    } else if (!xxl) {
      return desc?.length > 550 ? true : false;
    }

    return desc?.length < 650 ? false : true;
  }, [xs, sm, md, desc, lg, xl, xxl]);

  return (
    <section className={styles.container}>
      <BreadCrumb pageName={pageName} breadCrumb={breadCrumb}>
        {breadCrumbChildren}
      </BreadCrumb>

      <h1 className={styles.containerTitle}>{title}</h1>

      <div className={styles.containerDesc}>
        <div className={showMore ? styles.maxHeight : null} dangerouslySetInnerHTML={{ __html: desc || '' }} />
      </div>

      {desc &&
        showButton &&
        (showMore ? (
          <Button type="link" onClick={() => setShowMore(false)} className={styles.elipsisStyle}>
            Show more
          </Button>
        ) : (
          <Button type="link" onClick={() => setShowMore(true)} className={styles.elipsisStyle}>
            Show less
          </Button>
        ))}
    </section>
  );
};

export default Jumbotron;
